import { HttpError, } from '@wix/http-client';
import { resolveRequestDocument } from './document-utils';
export class GraphqlClientHttpError extends HttpError {
    constructor(errors, ...args) {
        super(...args);
        this.errors = errors;
    }
}
export function createGraphqlClient(httpClient, options = {}) {
    return new GraphqlClient(httpClient, options);
}
export class GraphqlClient {
    constructor(httpClient, options = {}) {
        this.httpClient = httpClient;
        this.serverUrl = options.serverUrl;
    }
    async query(document, variables, requestOptions) {
        var _a, _b, _c, _d;
        const { query, operationName } = resolveRequestDocument(document);
        const url = this.serverUrl || (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.serverUrl) || '/graphql-server/graphql';
        const opts = Object.assign(Object.assign({}, requestOptions), { url, method: 'POST', data: { query, variables, operationName } });
        const res = await this.httpClient.request(opts).catch((err) => {
            var _a, _b, _c;
            throw new GraphqlClientHttpError((_c = (_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.errors) !== null && _c !== void 0 ? _c : [], err);
        });
        return Object.assign(Object.assign({}, res), { data: (_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : {}, errors: (_d = (_c = res.data) === null || _c === void 0 ? void 0 : _c.errors) !== null && _d !== void 0 ? _d : [] });
    }
}
//# sourceMappingURL=graphql-client.js.map